import React from "react";
import "./sixthPage.css";

function SixthPage() {
  return (
    <div className="sixthpage-wrapper">
      <div className="heading1">
        <p>
          © Copyright <strong>ScaleFoster Media Private Limited.</strong> All
          Rights Reserved
        </p>
      </div>
      <div className="heading2">
        <p>
          Designed by <span style={{ color: "#4154f1" }}>BootstrapMade</span>
        </p>
      </div>
    </div>
  );
}

export default SixthPage;
